import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadDesignprocess'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'デザインプロセス デザインシステム コンポーネントライブラリ デザイン原則 デザインガイドライン figma'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/download/design-process/'}
        title="デザインプロセスガイドブック | 資料ダウンロード | i3DESIGN アイスリーデザイン"
        description="デザインプロセスは、顧客体験価値の高いプロダクトやサービスを提供するために、私たちが実際に取り組んでいるプロセスを可視化した資料です。"
      />
      <Template />
    </>
  )
}

export default Download
